'use client'

import { FilterValue } from "@/shared/types/type/search"
import { TREATMENT_ICON_MAP } from "@/shared/constants/icon-map"
import { useGetLocale } from "@/shared/hooks/useGetLocale"
import { Typography } from "@/shared/ui/atoms"
import Link from "next/link"

interface TreatmentListProps {
  treatmentList: FilterValue[]
  destination: "ranking" | "search"
}

const TreatmentList = ({ treatmentList, destination }: TreatmentListProps) => {
  const locale = useGetLocale()
  const page = destination === "ranking" ? "ranking" : "result"
  return (
    <>
      {treatmentList.map((item) => {
        const IconComponent = TREATMENT_ICON_MAP[item.id as keyof typeof TREATMENT_ICON_MAP]
        return (
          <Link
            key={item.id}
            href={`/${locale}/search/${page}?treatment=${item.id}`}
            aria-label={item.name}
            className="flex flex-col items-center gap-[6px]"
          >
            <div className="flex items-center justify-start rounded-[16px] bg-primary-50 p-[11px]">
              {IconComponent && <IconComponent className="text-primary-600" size={32} />}
            </div>
            <Typography size={13} lineHeight={14} className="text-start font-medium text-gray-600" whitespace="nowrap">
              {item.name}
            </Typography>
          </Link>
        )
      })}
    </>
  )
}

export default TreatmentList
